import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function AcceptableUse() {
  return (
    <PolicyPage title="Acceptable Use Policy">
      <p>This policy protects customers, camartzuno, and the reliable operation of the store.</p>

      <h2>Prohibited conduct</h2>
      <p>You must not use the site to:</p>
      <ul>
        <li>violate law, sanctions, court orders, privacy, publicity, consumer, or intellectual-property rights;</li>
        <li>commit fraud, use unauthorized payment credentials, evade purchase limits, or abuse promotions, returns, chargebacks, reviews, or customer support;</li>
        <li>upload malware, probe or bypass security, access non-public systems, or interfere with site availability;</li>
        <li>scrape, crawl, index, or automate requests in a way that ignores technical restrictions or creates unreasonable load;</li>
        <li>impersonate another person, misrepresent affiliation, submit deceptive content, or collect information about others without authority; or</li>
        <li>use site content or services to develop unlawful, infringing, deceptive, or competing materials without permission.</li>
      </ul>

      <h2>Enforcement</h2>
      <p>We may investigate suspected misuse and, where proportionate, limit access, cancel affected orders, preserve evidence, or report conduct to service providers or authorities. We will refund amounts due for cancelled orders as required by law. Enforcement does not waive other rights.</p>

      <h2>Security research</h2>
      <p>Good-faith security reports should follow our Responsible Disclosure Policy. Do not access customer data, disrupt service, use social engineering, or publicly disclose an unresolved vulnerability.</p>

      <h2>Report misuse</h2>
      <p>Email <ContactEmail /> with enough detail for us to review the issue. Do not send harmful files or sensitive third-party data unless requested through a secure channel.</p>
    </PolicyPage>
  );
}

export default AcceptableUse;
